import { MutationTree } from 'vuex';
import MarkersState from '@/store/modules/markers/MarkersState';

const mutations: MutationTree<MarkersState> = {
    setActiveMarkerId(state, markerId: string | null): void {
        state.activeMarkerId = markerId;
    },
    setActiveMarkerCategory(state, categoryId: string | null): void {
        state.activeMarkerCategory = categoryId;
    },
};

export default mutations;
